import { useMemo, useState } from 'react';
// components
import {
  CasEditForm,
  IEditForm,
  CasRHFDatePicker,
  CasRHFNumberField,
  CasStackRow,
  CasRHFSwitch,
  CasButton,
} from 'src/compass/shared/components';
import { FormMethodType } from 'src/compass/shared/components/CasForm/CasReactHookForm';
import { DateFormat, formatDate } from 'src/compass/shared/util/casMoment';
import Iconify from 'src/components/iconify';

import { DeadReportsSchema } from './DeadReportsSchema';

interface IDeadReportsForm extends IEditForm {
  showAddButton?: boolean;
}

export default function DeadReportsForm({
  row,
  onSaved,
  editFormAdditionalData,
  showAddButton,
}: IDeadReportsForm) {
  const { id } = row || {};
  const { endorsementId } = editFormAdditionalData || {};

  const defaultValues = useMemo(() => (id ? row : {}), [id, row]);

  const [formMethods, setFormMethods] = useState<FormMethodType>(null);
  const [hideCountField, setHideCountField] = useState(false);

  const onBeforeSave = (data: any) => ({
    ...data,
    endorsementId,
    date: formatDate(data.date, DateFormat.YMD),
  });

  return (
    <CasEditForm
      defaultValues={defaultValues}
      onSaved={onSaved}
      entity="Sce/Claims/DeadReports"
      schema={DeadReportsSchema}
      onBeforeSave={onBeforeSave}
      setFormMethods={setFormMethods}
    >
      <CasStackRow justifyContent={showAddButton ? 'space-around' : 'flex-start'}>
        <div>
          <CasRHFDatePicker name="date" label="Date" />
          <CasStackRow>
            {!hideCountField && <CasRHFNumberField type="number" name="count" label="Count" />}
            <CasRHFSwitch
              name="unspecified"
              label="Unspecified"
              onChange={(_, value) => {
                setHideCountField(value);
                if (value) {
                  formMethods?.clearErrors('count');
                  formMethods?.setValue('count', 0);
                }
              }}
            />
          </CasStackRow>
        </div>
        {showAddButton && (
          <CasStackRow alignItems="center">
            <CasButton type="submit" startIcon={<Iconify icon="mingcute:add-line" />}>
              Add
            </CasButton>
          </CasStackRow>
        )}
      </CasStackRow>
    </CasEditForm>
  );
}
